// src/law_pages/energy-reset/OfferER14.tsx
import { useEffect } from "react";

export default function OfferER14() {
  useEffect(() => {
    document.title = "Публичная оферта — Пакет ER-14 — Mira";
  }, []);

  return (
    <main className="mx-auto max-w-3xl px-4 py-6">
      <h1 className="text-2xl font-bold mb-2">
        Публичная оферта на предоставление доступа к цифровому контенту PWA «Mira» — Пакет ER-14 (v1.1)
      </h1>

      <p className="text-sm text-gray-600">
        <strong>Действует с:</strong> 25.08.2025
        <br />
        <strong>Оферент:</strong> Бабин Максим Викторович (самозанятый, НПД), ИНН 165048100405
        <br />
        <strong>Платформа:</strong>{" "}
        <a
          className="underline"
          href="https://24mira.ru"
          target="_blank"
          rel="noopener noreferrer"
        >
          https://24mira.ru
        </a>
        <br />
        <strong>Контакты:</strong>{" "}
        <a
          className="underline"
          href="mailto:stroimpechki@yandex.ru"
          rel="noopener noreferrer"
        >
          stroimpechki@yandex.ru
        </a>
      </p>

      <p className="mt-4">
        <a
          href="/docs/oferta_er-14_v1.1.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="underline font-medium"
        >
          Скачать PDF-версию
        </a>
      </p>

      <hr className="my-6" />

      <section className="space-y-4">
        <p>
          Настоящий документ является публичной офертой в смысле ст. 437 ГК РФ. Акцепт совершается действиями,
          указанными в разделе 3. Модель оказания услуги — SaaS/обеспечение удалённого доступа к цифровому контенту.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">1. Термины</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Платформа</strong> — PWA «Mira» (https://24mira.ru).</li>
          <li><strong>Пакет ER-14</strong> — цифровой пакет доступа к последовательности материалов «Energy Reset: 14 дней».</li>
          <li><strong>Доступ</strong> — удалённое предоставление возможности просмотра/использования материалов без передачи копий и прав на распространение.</li>
          <li><strong>Активационный код</strong> — разовый код, открывающий доступ к Пакету ER-14.</li>
          <li><strong>Партнёр</strong> — уполномоченное лицо, продающее активационные коды по договору с Оферентом.</li>
          <li><strong>Пользователь</strong> — физическое лицо, принявшее оферту.</li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">2. Предмет</h2>
        <p>
          Оферент оказывает возмездные услуги по обеспечению доступа к Пакету ER-14 и предоставляет Пользователю простую
          (неисключительную) лицензию на личное использование материалов в пределах Платформы.
        </p>
        <p>
          Материалы не являются медицинскими рекомендациями и не образуют образовательную программу, выдающую документы
          гособразца; сопровождение кураторов не предусмотрено, доступна техподдержка по работе сервиса.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">3. Порядок заключения (акцепт)</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>
            Акцептом оферты является: (а) оплата стоимости Пакета ER-14 через платёжный интерфейс (ЮKassa) и/или
            (б) ввод активационного кода с нажатием «Активировать» при отображении ссылки на оферту.
          </li>
          <li>
            Если Пользователь приобрёл активационный код у партнёра, договор с Оферентом считается заключённым в момент
            активации кода в Платформе. Покупка кода у партнёра без активации не влечёт заключение настоящего договора.
          </li>
          <li>
            Факт акцепта и дата начала доступа фиксируются техническими журналами Платформы (clientId, userId, время, источник).
          </li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">4. Формат и доступ</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Последовательная выдача:</strong> материалы выдаются ежедневно, последовательно, в течение 14 календарных дней с момента активации.</li>
          <li><strong>Без архивного доступа:</strong> материалы предыдущих дней не доступны; следующий день открывается поверх предыдущего независимо от выполнения.</li>
          <li><strong>Старт доступа:</strong> при оплате — с момента оплаты; при кодовой активации — с момента ввода кода.</li>
          <li><strong>Возраст:</strong> 18+.</li>
          <li>Оферент вправе обновлять/заменять материалы без ухудшения заявленного объёма.</li>
        </ul>

        <h3 className="text-lg font-semibold mt-4">4.5. Коды активации (правила)</h3>
        <ul className="list-disc pl-6 space-y-1">
          <li>Код является разовым идентификатором; повторное использование исключено.</li>
          <li>Код можно купить только у официальных партнёров, указанных в Приложении №2 и/или на странице <a className="underline" href="/partners">/partners</a>.</li>
          <li>Риск утраты/разглашения кода до активации несёт его владелец; после активации доступ привязывается к учётной записи.</li>
          <li>Если срок действия кода не указан при продаже партнёром — он составляет 12 месяцев с даты продажи.</li>
          <li>Оферент вправе аннулировать код и/или доступ при выявлении мошенничества (подделка, массовое распространение, брутфорс и т.п.) с направлением уведомления Пользователю.</li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">5. Стоимость и оплата</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li>Стоимость Пакета ER-14: <strong>499 ₽</strong>. Оплата — безналично через ЮKassa (ЮMoney).</li>
          <li>Оферент применяет НПД; чек формируется и направляется через «Мой Налог».</li>
          <li>
            Оплата через партнёров осуществляется по их правилам и договорам с Пользователем. Первичные документы по покупке кода
            оформляет партнёр; Оферент оформляет документы по оказанию доступа в предусмотренных случаях.
          </li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">6. Правила возвратов</h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>6.1. Безусловный возврат 7 дней.</strong> Полный возврат 100% в течение 7 календарных дней с даты начала доступа, независимо от объёма просмотренных материалов.</li>
          <li><strong>6.2. Ограничение по количеству.</strong> Не более одного безусловного возврата на Пользователя за Пакет ER-14 за всё время.</li>
          <li><strong>6.3. После 7 дней</strong> возврат не производится. Повторная покупка возможна, но безусловный возврат повторно не предоставляется.</li>
          <li><strong>6.4. Порядок запроса.</strong> Заявление на email: <a className="underline" href="mailto:stroimpechki@yandex.ru">stroimpechki@yandex.ru</a>. Решение — до 5 рабочих дней; перечисление — тем же способом оплаты до 10 банковских дней после одобрения.</li>
          <li><strong>6.5. Прекращение доступа.</strong> При одобрении возврата доступ прекращается немедленно.</li>
          <li><strong>6.6. Анти-злоупотребление.</strong> Оферент вправе отказать при выявлении обхода ограничений (мультиаккаунты и т.п.) с мотивированным ответом.</li>
          <li><strong>6.7. Возвраты по кодам партнёров.</strong> До активации кода — возврат у партнёра по его правилам. После активации действует настоящая политика возвратов; использованный код повторной активации не подлежит.</li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">7. Права и обязанности сторон</h2>
        <p>
          Оферент обеспечивает доступ в заявленном формате и оказывает техподдержку по работе Платформы. Пользователь
          использует материалы лично, не передаёт доступ третьим лицам; соблюдает нормы этики; действует в пределах
          своего самочувствия. Оферент может временно ограничить доступ при нарушении оферты.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">8. Дисклеймеры</h2>
        <p>
          Материалы не являются медицинскими рекомендациями; при наличии противопоказаний Пользователь обращается к врачу.
          В ряде заданий предусмотрены мягкие альтернативы; при дискомфорте выполнение следует прекратить.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">9. Интеллектуальные права</h2>
        <p>
          Все материалы охраняются. Пользователь получает личную неисключительную лицензию на срок прохождения Пакета ER-14;
          копирование, публикация и распространение без письменного согласия Оферента запрещены.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">10. Персональные данные</h2>
        <p>
          Обработка ПД регулируется{" "}
          <a
            className="underline"
            href="/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Политикой ПД Mira
          </a>
          . Отдельные согласия (маркетинг, профилирование, передача партнёрам) собираются в интерфейсе при необходимости.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">11. Изменение условий</h2>
        <p>
          Оферент вправе изменять условия оферты публикацией новой редакции. Для уже активированных доступов применяются
          условия на дату акцепта, если иное не согласовано с Пользователем.
        </p>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">12. Урегулирование споров</h2>
        <p>
          Претензии направляются на email Оферента; срок рассмотрения — до 10 рабочих дней. Применимое право — право
          Российской Федерации.
        </p>
      </section>

      <section className="space-y-2 mt-6">
        <h2 className="text-xl font-semibold">13. Реквизиты Оферента</h2>
        <p>
          Бабин Максим Викторович, самозанятый (НПД), ИНН 165048100405
          <br />
          Email:{" "}
          <a className="underline" href="mailto:stroimpechki@yandex.ru">
            stroimpechki@yandex.ru
          </a>
          <br />
          Адрес для корреспонденции: 423812, Россия, Республика Татарстан, г. Набережные Челны, бульвар 60-летия Октября, д. 8, кв. 2
        </p>
      </section>

      <hr className="my-6" />

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">
          Приложение №1. Паспорт Пакета ER-14 «Energy Reset: 14 дней»
        </h2>
        <ul className="list-disc pl-6 space-y-1">
          <li><strong>Формат:</strong> самостоятельное прохождение; ежедневная выдача заданий (текст/аудио/видео) ~2–7 минут.</li>
          <li><strong>Кураторы:</strong> не предусмотрены; доступна техподдержка по email.</li>
          <li><strong>Старт доступа:</strong> с момента оплаты или активации кода.</li>
          <li><strong>Длительность:</strong> 14 дней с последовательной выдачей.</li>
          <li><strong>Доступ к прошедшим дням:</strong> не предоставляется (следующий день открывается поверх предыдущего).</li>
          <li>
            <strong>Сопровождение:</strong> техподдержка:{" "}
            <a className="underline" href="mailto:stroimpechki@yandex.ru">
              stroimpechki@yandex.ru
            </a>{" "}
            (время ответа до 2 рабочих дней).
          </li>
          <li><strong>Стоимость:</strong> 499 ₽.</li>
          <li><strong>Политика возвратов:</strong> см. раздел 6 настоящей оферты.</li>
          <li><strong>Возраст:</strong> 18+.</li>
        </ul>
      </section>

      <section className="space-y-3 mt-6">
        <h2 className="text-xl font-semibold">Приложение №2. Официальные партнёры</h2>
        <p>
          Актуальный перечень официальных партнёров публикуется и обновляется на странице:{" "}
          <a className="underline" href="/partners">
            https://24mira.ru/partners
          </a>
          . Изменения перечня вступают в силу с момента публикации на указанной странице.
        </p>
      </section>
    </main>
  );
}
